import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

declare let $: any;

@Component({
  selector: 'app-consultar-persona',
  templateUrl: './consultar-persona.component.html',
  styleUrls: ['./consultar-persona.component.css']
})
export class ConsultarPersonaComponent implements OnInit {
  @ViewChild('dataTable', {static: false}) table: ElementRef;
  dataTable: any;
  dtOptions: any;

  constructor() {}

  ngOnInit() {
    this.dtOptions = {
      dom: 'Bfrtip',
      buttons: ['copy', 'excel']
    };
    this.dataTable = $(this.table.nativeElement);
    this.dataTable.dataTable(this.dtOptions);
  }
}
